import React, { useState, useEffect } from 'react';
import { Form, Radio, Button } from 'antd';
import Typing from '../Typing/Typing';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import * as Api from '../../services/api';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import CmpsNotValid from '../CmpsNotValid/CmpsNotValid';
import * as Utils from '../../services/utils';

function CmpsTime({onComplete, onScroll, form, onError, onShowInput, onReset}) {
  const [showtime, setShowtime] = useState(false);
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);
  const [listaOrari, setListaOrari] = useState(false);
  const [itemsToShow, setItemsToShow] = useState(9);

  const onChange = (e) => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/scelta-orario');
    setMsg(form.getFieldValue("ora").label);
    onComplete('step5');
  }

  const showMoreLess = () => {
    if (itemsToShow + 3 <= listaOrari.length) {
      setItemsToShow(itemsToShow + 3);
    } else {
      setItemsToShow(9);
    }
    setTimeout(() => {
      onScroll();
    });
  }

  const reset = () => {
    onReset();
  }

  useEffect(() => {
    onShowInput(false);
    Api.getOrariDisponibili({
      Giorno: form.getFieldValue("data").easyDate,
      CodFiliale: form.getFieldValue("filiale").idFiliale
    }).then(function (response) {
      const list = response.data.orariDisponibili.map((time) => {
        let hour = time.hour < 10 ? '0'+time.hour : time.hour;
        let minute = time.minute < 10 ? '0'+time.minute : time.minute
        return {
          label: hour+':'+minute,
          value: time,
          disponibile: time.disponibile
        }
      });
      setListaOrari(list);
      if(response.timings && response.timings.elapsedTime) {
        if(response.timings.elapsedTime <= 2000) {
          setTimeout(() => {
            setTyping(false);
            onScroll();
          }, 2000);
        } else {
          setTyping(false);
          onScroll();
        }
      } else {
        setTyping(false);
        onScroll();
      }
    })
    .catch(function (error) {
      console.log(error);
      onError();
    });
  }, []);

  return (
    <section id="time">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300} last={listaOrari.length > 0 ? true : false}>
              <span className="bubble">Quale orario preferisci?</span>
            </CmpsAnimation>
            {listaOrari.length <= 0 && (
              <>
                <CmpsNotValid msg="Non ci sono orari disponibili per il giorno e la filiale selezionata. Ti consigliamo di procedere con una nuova richiesta provando una combinazione differente." />
                <CmpsAnimation wait={2200}>
                  <Button className={['cmps_btn', 'cmps_btn__redirect']} onClick={reset}>RICOMINCIA!</Button>
                </CmpsAnimation>
              </>
            )}
            {(!msg && listaOrari.length > 0) && (
              <CmpsAnimation wait={600}>
                <Form.Item className={`cmps_radio_button cmps_radio_button__grid`} name="ora">
                  <Radio.Group onChange={onChange}>
                    {listaOrari.slice(0, itemsToShow).map((ora, index) =>
                      <Radio.Button key={index} value={ora} disabled={!ora.disponibile}>
                        {ora.label}
                      </Radio.Button>
                    )}
                  </Radio.Group>
                </Form.Item>
                <p className={`show_more`} onClick={showMoreLess}>
                  {itemsToShow===listaOrari.length ? 'Mostra meno orari' : 'Mostra orari successivi'}
                </p>
                <div className="info">
                  <span className="time"><Timestamp /></span>
                </div>
              </CmpsAnimation>
            )}
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
    </section>
  );

} 

export default CmpsTime;
